// @flow weak

import _ from 'lodash/fp';
import {combineReducers} from 'redux';
import {
  CUSTOM_ROW_GET_REQUEST, CUSTOM_ROW_GET_SUCCESS,
  CUSTOM_ROW_GET_FAILURE,
  CUSTOM_ROW_CREATE_REQUEST, CUSTOM_ROW_CREATE_SUCCESS,
  CUSTOM_ROW_CREATE_FAILURE, CUSTOM_ROW_UPDATE_REQUEST,
  CUSTOM_ROW_UPDATE_SUCCESS, CUSTOM_ROW_UPDATE_FAILURE,
  CUSTOM_ROW_ADD_FILE, CUSTOM_ROW_REMOVE_FILE,
  CUSTOM_ROW_UPLOAD_FILE, CUSTOM_ROW_ABORT_FILE_UPLOAD,
  CUSTOM_ROW_REMOVE_REQUEST, CUSTOM_ROW_REMOVE_SUCCESS,
  CUSTOM_ROW_REMOVE_FAILURE, CUSTOM_ROW_DATA_GET_REQUEST,
  CUSTOM_ROW_DATA_GET_SUCCESS, CUSTOM_ROW_DATA_GET_FAILURE,
  CLEAR, RESET,
} from '../actions/customRowView';
import {SET_DIRTY} from '../actions/form';

const customRowHasLoaded = (state = false, action) => {
  switch (action.type) {
    case CUSTOM_ROW_GET_SUCCESS:
    case CUSTOM_ROW_GET_FAILURE:
      return true;
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const customRowIsFetching = (state = false, action) => {
  switch (action.type) {
    case CUSTOM_ROW_GET_REQUEST:
    case CUSTOM_ROW_CREATE_REQUEST:
    case CUSTOM_ROW_UPDATE_REQUEST:
    case CUSTOM_ROW_REMOVE_REQUEST:
      return true;
    case CUSTOM_ROW_GET_SUCCESS:
    case CUSTOM_ROW_GET_FAILURE:
    case CUSTOM_ROW_CREATE_SUCCESS:
    case CUSTOM_ROW_CREATE_FAILURE:
    case CUSTOM_ROW_UPDATE_SUCCESS:
    case CUSTOM_ROW_UPDATE_FAILURE:
    case CUSTOM_ROW_REMOVE_SUCCESS:
    case CUSTOM_ROW_REMOVE_FAILURE:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const customRowDataIsFetching = (state = false, action) => {
  switch (action.type) {
    case CUSTOM_ROW_DATA_GET_REQUEST:
      return true;
    case CUSTOM_ROW_DATA_GET_SUCCESS:
    case CUSTOM_ROW_DATA_GET_FAILURE:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const defaultCustomRowState = {
  active: null,
  files: {},
};

const customRow = (state = defaultCustomRowState, action) => {
  switch (action.type) {
    case CUSTOM_ROW_GET_SUCCESS:
    case CUSTOM_ROW_CREATE_SUCCESS:
    case CUSTOM_ROW_UPDATE_SUCCESS:
      return {
        ...state,
        active: action.row,
        files: {
          image: action.row.image,
        },
      };
    case CUSTOM_ROW_REMOVE_FILE:
      return {
        ...state,
        files: {
          ...state.files,
          [action.name]: null,
        },
      };
    case CUSTOM_ROW_ADD_FILE:
      return {
        ...state,
        files: {
          ...state.files,
          [action.name]: action.metadata,
        },
      };
    case RESET:
      return {
        ...state,
        files: state.active ? {
          image: state.active.image,
        } : {},
      };
    case CUSTOM_ROW_REMOVE_SUCCESS:
    case CLEAR:
      return defaultCustomRowState;
    default:
      return state;
  }
};

const order = (state = null, action) => {
  switch (action.type) {
    case CUSTOM_ROW_GET_SUCCESS:
      return action.order;
    case CLEAR:
      return null;
    default:
      return state;
  }
};

const customRowError = (state = null, action) => {
  switch (action.type) {
    case CUSTOM_ROW_GET_SUCCESS:
    case CUSTOM_ROW_CREATE_SUCCESS:
    case CUSTOM_ROW_UPDATE_SUCCESS:
    case CUSTOM_ROW_REMOVE_SUCCESS:
    case CLEAR:
      return null;
    case CUSTOM_ROW_CREATE_FAILURE:
    case CUSTOM_ROW_UPDATE_FAILURE:
    case CUSTOM_ROW_GET_FAILURE:
    case CUSTOM_ROW_REMOVE_FAILURE:
      return action.error;
    default:
      return state;
  }
};

const customRowUploadIds = (state = {}, action) => {
  switch (action.type) {
    case CUSTOM_ROW_UPLOAD_FILE:
      return {
        ...state,
        [action.name]: action.tempId,
      };
    case CUSTOM_ROW_ABORT_FILE_UPLOAD:
      return _.omitBy(u => u === action.tempId, state);
    case CLEAR:
      return {};
    default:
      return state;
  }
};

const customRowisDirty = (state = false, action) => {
  switch (action.type) {
    case SET_DIRTY:
      return action.form === 'customRow'
        ? action.dirty
        : state;
    case CUSTOM_ROW_GET_SUCCESS:
    case CUSTOM_ROW_UPDATE_SUCCESS:
    case CUSTOM_ROW_CREATE_SUCCESS:
    case CUSTOM_ROW_REMOVE_SUCCESS:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const notArchived = _.filter({archived: null});

const includeId = id =>
  _.filter(t => t.id === id || !t.archived);

const filterSuppliers = customRow =>
  customRow && !!customRow.supplierId
    ? includeId(customRow.supplierId)
    : notArchived;

const defaultSupplierState = {
  list: [],
  filteredList: [],
};

const suppliers = (state = {}, action) => {
  switch (action.type) {
    case CUSTOM_ROW_DATA_GET_SUCCESS:
      return {
        ...state.suppliers,
        list: action.suppliers,
        filteredList: filterSuppliers(state.customRow.active)(action.suppliers),
      };
    case CUSTOM_ROW_UPDATE_SUCCESS:
      return {
        ...state.suppliers,
        filteredList: filterSuppliers(state.customRow.active)(state.suppliers.list),
      };
    default:
      return state.suppliers;
  }
};

const filterProductTypes = customRow =>
  customRow && !!customRow.productTypeId
    ? includeId(customRow.productTypeId)
    : notArchived;

const defaultProductTypesState = {
  list: [],
  filteredList: [],
};

const productTypes = (state = {}, action) => {
  switch (action.type) {
    case CUSTOM_ROW_DATA_GET_SUCCESS:
      return {
        ...state.productTypes,
        list: action.productTypes,
        filteredList: filterProductTypes(state.customRow.active)(action.productTypes),
      };
    case CUSTOM_ROW_UPDATE_SUCCESS:
      return {
        ...state.productTypes,
        filteredList: filterProductTypes(state.customRow.active)(state.productTypes.list),
      };
    default:
      return state.productTypes;
  }
};

const filterWorkerTypes = customRow =>
  customRow && !!customRow.workerTypeId
    ? includeId(customRow.workerTypeId)
    : notArchived;

const defaultWorkerTypesState = {
  list: [],
  filteredList: [],
};

const workerTypes = (state = {}, action) => {
  switch (action.type) {
    case CUSTOM_ROW_DATA_GET_SUCCESS:
      return {
        ...state.workerTypes,
        list: action.workerTypes,
        filteredList: filterWorkerTypes(state.customRow.active)(action.workerTypes),
      };
    case CUSTOM_ROW_UPDATE_SUCCESS:
      return {
        ...state.workerTypes,
        filteredList: filterWorkerTypes(state.customRow.active)(state.workerTypes.list),
      };
    default:
      return state.workerTypes;
  }
};

const filterRoomTypes = customRow =>
  customRow && !!customRow.roomTypeId
    ? includeId(customRow.roomTypeId)
    : notArchived;

const defaultRoomTypesState = {
  list: [],
  filteredList: [],
};

const roomTypes = (state = {}, action) => {
  switch (action.type) {
    case CUSTOM_ROW_DATA_GET_SUCCESS:
      return {
        ...state.roomTypes,
        list: action.roomTypes,
        filteredList: filterRoomTypes(state.customRow.active)(action.roomTypes),
      };
    case CUSTOM_ROW_UPDATE_SUCCESS:
      return {
        ...state.roomTypes,
        filteredList: filterRoomTypes(state.customRow.active)(state.roomTypes.list),
      };
    default:
      return state.roomTypes;
  }
};

const filterRooms = customRow =>
  customRow && !!customRow.room
    ? includeId(customRow.room)
    : notArchived;

const defaultRoomsState = {
  list: [],
  filteredList: [],
};

const rooms = (state = {}, action) => {
  switch (action.type) {
    case CUSTOM_ROW_DATA_GET_SUCCESS:
      return {
        ...state.rooms,
        list: action.rooms,
        filteredList: filterRooms(state.customRow.active)(action.rooms),
      };
    case CUSTOM_ROW_UPDATE_SUCCESS:
      return {
        ...state.rooms,
        filteredList: filterRooms(state.customRow.active)(state.rooms.list),
      };
    default:
      return state.rooms;
  }
};

const reducers = combineReducers({
  customRow,
  order,
  uploadIds: customRowUploadIds,
  isFetching: customRowIsFetching,
  dataIsFetching: customRowDataIsFetching,
  error: customRowError,
  isDirty: customRowisDirty,
  hasLoaded: customRowHasLoaded,
  suppliers: (s = defaultSupplierState) => s,
  productTypes: (s = defaultProductTypesState) => s,
  workerTypes: (s = defaultWorkerTypesState) => s,
  roomTypes: (s = defaultRoomTypesState) => s,
  rooms: (s = defaultRoomsState) => s,
});

const customRowView = (state, action) => {
  const newState = reducers(state, action);
  return {
    ...newState,
    suppliers: suppliers(newState, action),
    productTypes: productTypes(newState, action),
    workerTypes: workerTypes(newState, action),
    roomTypes: roomTypes(newState, action),
    rooms: rooms(newState, action),
  };
};

export default customRowView;



// WEBPACK FOOTER //
// ./src/reducers/customRowView.js